var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Notification"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.53606 4.10259C3.75133 6.51413 3.77206 11.7279 5.16004 14.4818C6.19742 16.54 6.20248 15.7779 6.28308 18.8859C6.63949 23.1931 13.1951 21.723 16.5617 20.0262C19.9272 18.3299 25.0087 13.9349 21.7595 11.0857C19.3091 9.17204 19.9247 9.62134 18.8874 7.56308C17.4994 4.80918 13.3198 1.69157 8.53606 4.10259Z",
    stroke: "#060623",
    strokeWidth: 1.97727,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 3",
    d: "M20.44 21.5199C19.7994 23.7237 17.6297 24.8395 15.4548 24.0324",
    stroke: "#060623",
    strokeWidth: 1.97727,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/Notifications.5185eb890ce235f8cc639c26d660e6ea.svg";
export { ForwardRef as ReactComponent };